import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {
  isLoading:boolean = false;
  isEmailValid:boolean = false;
  isMobileValid:boolean = false;
  showBadEmail:boolean = true;
  showBadMobile:boolean = true;
  showBadShift:boolean = true;
  displayConfirmMessage:boolean = false;
  currentLanguage = 'en';
  shiftOptions:any = [
    { value: 'Days', title: 'Days', selected: false },
    { value: 'Nights', title: 'Nights', selected: false },
    { value: 'Weekends', title: 'Weekends', selected: false },
    { value: 'Flexible', title: 'Flexible', selected: false },
  ]
  interestOptions:any = [
    { value: 'Forklift', title: 'Forklift' },
    { value: 'General Warehouse', title: 'General Warehouse' },
    { value: 'Clerical', title: 'Clerical' },
    { value: 'Technician', title: 'Technician' },
    { value: 'Other', title: 'Other' },
  ]
  spanishShiftOptions:any = [
    { value: 'Days', title: 'Días', selected: false },
    { value: 'Nights', title: 'Noches', selected: false },
    { value: 'Weekends', title: 'Fines de semana', selected: false },
    { value: 'Flexible', title: 'Flexible', selected: false },
  ]
  spanishInterestOptions:any = [
    { value: 'Forklift', title: 'Forklift' },
    { value: 'General Warehouse', title: 'Almacén general' },
    { value: 'Clerical', title: 'Clerical' },
    { value: 'Technician', title: 'Técnica/ Técnico' },
    { value: 'Other', title: 'Ortra/Otro' },
  ]
  stateOptions:any = [
    { value: 'Alabama', title: 'Alabama'},
    { value: 'Alaska', title: "Alaska"},
    { value: "Arizona", title: "Arizona"},
    { value: "Arkansas", title: "Arkansas"},
    { value: 'California', title: "California"},
    { value: 'Colorado', title: "Colorado"},
    { value: "Connecticut", title: "Connecticut"},
    { value: "Delaware", title: "Delaware"},
    { value: "Florida", title: "Florida"},
    { value: "Georgia", title: "Georgia"},
    { value: "Hawaii", title: "Hawaii"},
    { value: "Idaho", title: "Idaho"},
    { value: "Illinois", title: "Illinois"},
    { value: "Indiana", title: "Indiana"},
    { value: "Iowa", title: "Iowa"},
    { value: "Kansas", title: "Kansas"},
    { value: "Kentucky", title: "Kentucky"},
    { value: "Louisiana", title: "Louisiana"},
    { value: 'Maine', title: "Maine"},
    { value: "Maryland", title: "Maryland"},
    { value: "Massachusetts", title: "Massachusetts"},
    { value: "Michigan", title: "Michigan"},
    { value: "Minnesota", title: "Minnesota"},
    { value: "Mississippi", title: "Mississippi"},
    { value: "Missouri", title: "Missouri"},
    { value: "Montana", title: "Montana"},
    { value: "Nebraska", title: "Nebraska"},
    { value: "Nevada", title: "Nevada"},
    { value: "New Hampshire", title: "New Hampshire"},
    { value: 'New Jersey', title: "New Jersey"},
    { value: 'New Mexico', title: "New Mexico"},
    { value: 'New York', title: "New York"},
    { value: "North Carolina", title: "North Carolina"},
    { value: "North Dakota", title: "North Dakota"},
    { value: "Ohio", title: "Ohio"},
    { value: "Oklahoma", title: "Oklahoma"},
    { value: "Oregon", title: "Oregon"},
    { value: "Pennsylvania", title: "Pennsylvania"},
    { value: "Rhode Island", title: "Rhode Island"},
    { value: "South Carolina", title: "South Carolina"},
    { value: "South Dakota", title: "South Dakota"},
    { value: "Tennessee", title: "Tennessee"},
    { value: "Texas", title: "Texas"},
    { value: "Utah", title: "Utah"},
    { value: "Vermont", title: "Vermont"},
    { value: "Virginia", title: "Virginia"},
    { value: "Washington", title: "Washington"},
    { value: "West Virginia", title: "West Virginia"},
    { value: "Wisconsin", title: "Wisconsin"},
    { value: "Wyoming", title: "Wyoming"},
  ]
  userDetails = {
    firstName: null,
    lastName: null,
    mobile: null,
    email: null,
    state: null,
    city: null,
    positionTitle: null,
    currentPayRate: null,
    currentShift: null,
    workDuration: null,
    staffingAgency: null,
    additionalNotes: null,
    smsOptIn: false
  };

  constructor(private http: HttpClient) { }

  ngOnInit() {
  }

  onEmailChange() {
    const emailregex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailregex.test(this.userDetails.email)) {
      this.showBadEmail = true;
      this.isEmailValid = false;
    } else {
      this.showBadEmail = false;
      this.isEmailValid = true;
    }
  }

  onMobileChange() {
    const mobileregex = /^\d{3}-?\d{3}-?\d{4}$/;
    if (!mobileregex.test(this.userDetails.mobile)) {
      this.showBadMobile = true;
      this.isMobileValid = false;
    } else {
      this.showBadMobile = false;
      this.isMobileValid = true;
    }
  }

  onShiftChange() {
    if (this.userDetails.currentShift) {
      this.showBadShift = false
    } else {
      this.showBadShift = true
    }
  }

  submitForm(form: any): void {
    this.isLoading = true;
    console.log("!!!DETAILS", this.userDetails);
    if (this.isEmailValid && this.isMobileValid && form.valid) {
      console.log("!!!APPLYING")
      this.showBadEmail = false;
      this.showBadMobile = false;
      return this.apply(form)
    }
  }

  translateEmptyStringsToNull(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (obj[key] === '') {
          obj[key] = null;
        }
      }
    }
    return obj;
  }

  apply(form: any): any {
    const url = 'https://iJilityBHApp.newburypartnersapps.com/iJility-1.0/custom/form/submitVendorForm?apiKey=4D661061-0100-1838-289984C044B6228C';
    let payload;
    payload = this.translateEmptyStringsToNull(this.userDetails);
    return new Promise((resolve, reject) => {
      this.http.post(url, payload).toPromise()
      .then((res) => {
        this.isLoading = false;
        form.reset();
        this.displayConfirmMessage = true;
        setTimeout(() => {
          this.displayConfirmMessage = false;
          window.location.href = "https://ijility.com/app-confirmation/?eid=s1YrUaoQzTTdm%2FP3uwIQRTYF7jKc8vVemiuNwpSowlWIxGCfvUtetGEe8j82721JNKdUOkfvYoiw%2FzxsH9T4kprH9K%2Bi%2BzkqXBZ8lsMbIVWGQS3Ehg%3D%3D"
        }, 3000)
      }, err => {
        this.isLoading = false;
        console.log("!!!ERR", err)
      })
    });
  }

}
